import axios from 'axios';

export default {
    addType(payload) {
        return axios.post('/workstation/addType/', payload);
    },
    updateType(payload) {
        return axios.post('/workstation/updateType/', payload);
    },
    fetchTypeById(id) {
        return axios.post('/workstation/fetchTypeById/', { id });
    },
};
